<template>
  <div class="page-mine">
    <div class="mine-header">
      <div class="setting">
        <img class="icon-msg" :src="msgIcon" v-show="false" />
        <img class="icon-set" :src="setIcon" @click="handleClickSetting" />
      </div>
      <img class="header-img" :src="avatarDotIcon" />
      <img class="avatar" v-if="token && userInfo.photo" :src="getCdnImgByStyle(userInfo.photo, '200')" />
      <img class="avatar" v-if="!token || !userInfo.photo" :src="appLogo" />
      <template v-if="token">
        <div class="info-wrap">
          <div class="info-item">
            <span class="nickname">{{ userInfo.cnName }}</span>
            <!-- <span class="mobile" v-if="userInfo.mobile">{{ getHiddenPhone(userInfo.mobile) }}</span> -->
          </div>
          <div class="info-item tbAccount" v-if="channel === 'tbk' && tbAccountName">
            <div class="tb-wrap">
              <span class="bind-tip">淘宝账户</span><span class="tb-account">{{ tbAccountName }}</span>
            </div>
          </div>
          <div class="info-item" v-if="channel === 'tbk' && !tbAccountName">
            <div class="tb-wrap bind">
              <span class="bind-tip">未绑定淘宝账号</span><span class="btn-bind" @click="handleClickBindTb">立即绑定</span>
            </div>
          </div>
          <div class="info-item mobile-wrap" v-if="channel !== 'tbk'">
            <span class="mobile-wrap">{{ getHiddenPhone(userInfo.mobile) }}</span>
          </div>
        </div>
      </template>
      <template v-if="!token">
        <div class="info-wrap needLogin" @click="handleClickLogin">
          <span class="nickname">点击登录</span>
          <img class="arrow-right" :src="intoIcon" />
        </div>
      </template>
    </div>
    <div class="mine-body">
      <!-- 我的订单 -->
      <MineMenu border :list="myOrderList" @clickItem="handleClickMenu($event, 1)" />
    </div>
    <!-- 已结算收益 -->
    <MineMenu :list="settledProfitList" @clickItem="handleClickMenu($event, 2)" />
    <!-- 待结算收益 -->
    <MineMenu :list="unSettledProfitList" @clickItem="handleClickMenu($event, 3)" />
    <!-- 工具箱 -->
    <div class="tool-wrap">
      <div class="tool-item" v-for="item in toolList" @click="handleClickMenu(item, 4)" :key="item.id">
        <div class="tool-icon" :class="{ icon: item.icon }" :style="`${item.icon ? `background-image:url(${item.icon})` : ''}`">
          {{ item.icon ? '' : item.value }}
        </div>
        <div class="tool-name">{{ item.name }}</div>
      </div>
    </div>
    <VphTabs />
  </div>
</template>

<script>
import Consts from '@/common/consts'
import { getHiddenPhone, isWeiXin } from '@/utils/help'
import { mapGetters } from 'vuex'
import LoginService from '@/services/login'
import MineMenu from '@/components/mineMenu'
import _AP from '@/utils/ap'
import VphTabs from '@/components/vphTabs'
export default {
  name: 'mine',
  components: {
    MineMenu,
    VphTabs,
  },
  data() {
    return {
      channel: 'vph',
      tbAccountName: '', // 已绑定的淘宝账号
      getHiddenPhone: getHiddenPhone,
      appLogo: require('../../assets/images/app_logo.png'),
      intoIcon: require('../../assets/images/ic_white_into.png'),
      avatarDotIcon: require('../../assets/images/avatar_dot.png'),
      msgIcon: require('../../assets/images/mine_msg.png'),
      setIcon: require('../../assets/images/mine_set.png'),
      myOrderList: [
        // 我的订单
        { id: -1, name: '我的订单', key: '', value: '', icon: require('../../assets/images/menu/order.png') },
        { id: 0, name: '全部', key: '', value: '', icon: require('../../assets/images/order/icon_order_1.png') },
        { id: 12, name: '待结算', key: '', value: '', icon: require('../../assets/images/order/icon_order_2.png') },
        { id: 3, name: '已结算', key: '', value: '', icon: require('../../assets/images/order/icon_order_3.png') },
        { id: 13, name: '已失效', key: '', value: '', icon: require('../../assets/images/order/icon_order_4.png') },
      ],
      settledProfitList: [
        // 已结收益
        { id: -1, name: '已结收益', key: '', value: '0', icon: require('../../assets/images/menu/unsettled_profit.png') },
        { id: 0, name: '全部', key: 'money', value: '0' },
        { id: 1, name: '今日', key: 'todayMoney', value: '0' },
        { id: 2, name: '本月', key: 'currMoney', value: '0' },
        { id: 3, name: '上月', key: 'lastMoney', value: '0' },
      ],
      unSettledProfitList: [
        // 待结收益
        { id: -2, name: '待结收益', key: '', value: '0', icon: require('../../assets/images/menu/settled_profit.png') },
        { id: 0, name: '全部', key: 'money', value: '0' },
        { id: 1, name: '今日', key: 'todayMoney', value: '0' },
        { id: 2, name: '本月', key: 'currMoney', value: '0' },
        { id: 3, name: '上月', key: 'lastMoney', value: '0' },
      ],
      toolList: [
        // 工具列表
        { id: 0, name: '团队订单', key: '', value: '', icon: require('../../assets/images/menu/team_order.png') },
        { id: 1, name: '我的金豆', key: '', value: '', icon: require('../../assets/images/menu/bean.png') },
        // { id: 2, name: '商品收藏', key: '', value: '', icon: require('../../assets/images/menu/mark.png') },
        // { id: 3, name: '订单找回', key: '', value: '', icon: require('../../assets/images/menu/query.png') },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'userInfo',
      'authTbAccountName',
    ]),
  },
  created() {
    this.initData()
  },
  watch: {
    token() {
      this.initData()
    },
    authTbAccountName() {
      this.tbAccountName = this.authTbAccountName || ''
    }
  },
  activated() {
    if (this.authTbAccountName && !this.tbAccountName) {
      // 刚绑定, 需刷新
      this.checkBindTb()
    }
  },
  methods: {
    initData() {
      if (this.token) {
        this.tbAccountName = this.authTbAccountName || ''
        this.$http[this.channel].settledProfitBalance().then(res => {
          for (let item of this.settledProfitList) {
            if (item.key) {
              item.value = `${res.data[item.key]}`
            }
          }
        })
        this.$http[this.channel].unsettledProfitBalance().then(res => {
          for (let item of this.unSettledProfitList) {
            if (item.key) {
              item.value = `${res.data[item.key]}`
            }
          }
        })
      } else {
        for (let item of this.settledProfitList) {
          if (item.key) {
            item.value = '0'
          }
        }
        for (let item of this.unSettledProfitList) {
          if (item.key) {
            item.value = '0'
          }
        }
      }
    },
    /**
     * 检查是否绑定淘宝账户
     */
    checkBindTb() {
      this.tbAccountName = ''
      LoginService.checkBindTb((isBind, data) => {
        if (isBind) {
          this.tbAccountName = data.tbAccountName
        }
      }, 0)
    },
    /**
     * 点击菜单
     */
    handleClickMenu(menuItem, menuType) {
      if (!this.token) {
        this.handleClickLogin()
        return
      }
      if (menuType === 1) {
        // 我的订单
        this.$router.push({ name: 'orders', query: { channel: this.channel, type: 1, state: menuItem.id } })
      } else if (menuType === 2) {
        // 已结收益
        this.$router.push({ name: 'profits', query: { channel: this.channel, type: 1, state: menuItem.id } })
      } else if (menuType === 3) {
        // 待结收益
        this.$router.push({ name: 'profits', query: { channel: this.channel, type: 2, state: menuItem.id } })
      } else if (menuType === 4) {
        this.navigateTo(menuItem.id)
      }
    },
    /**
     * 跳转到工具箱页面
     */
    navigateTo(id) {
      switch (id) {
        case 0: // 团队订单
          this.$router.push({ name: 'orders', query: { channel: this.channel, type: 2, state: 0 } })
          break
        case 1: // 金豆
          this.$router.push({ name: 'profits', query: { channel: this.channel, type: 3, state: 0 } })
          break
        case 2: // 商品收藏
          this.$router.push({ name: 'productCollection' })
          break
        case 3: // 订单查询
          this.$router.push({ name: 'orderQuery' })
          break
      }
    },
    /**
     * 点击设置
     */
    handleClickSetting() {
      if (this.token) {
        this.$router.push({ name: 'setting' })
      } else {
        this.handleClickLogin()
      }
    },
    /**
     * 去登录
     */
    handleClickLogin() {
      this.$router.push({ name: 'login' })
    },
    /**
     * 点击绑定淘宝账号
     */
    handleClickBindTb() {
      const authURL = LoginService.getTaobaoAuthUrl()
      if (isWeiXin()) {
        _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, authURL)
      } else {
        window.location.href = authURL
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-mine {
  position: relative;
  min-height: 100%;
  background-color: #f7f7f7;
  .mine-header {
    position: relative;
    height: 2.4rem;
    padding: 0 0.4rem;
    border-bottom-left-radius: 100% 10%;
    border-bottom-right-radius: 100% 10%;
    background: linear-gradient(180deg, #fd424d 60%, #fa1921);
    .setting {
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      display: flex;
      align-items: center;
      .icon-msg,
      .icon-set {
        height: 0.5rem;
        margin-left: 0.32rem;
        cursor: pointer;
        &:active {
          opacity: 0.5;
        }
      }
    }
    .header-img {
      position: absolute;
      width: 0.78rem;
      z-index: 1;
      top: 0.4rem;
      left: 0;
    }
    .avatar {
      position: absolute;
      top: 0.2rem;
      left: 0.36rem;
      width: 1.24rem;
      height: 1.24rem;
      border-radius: 50%;
      z-index: 2;
      overflow: hidden;
      background: #d39292;
      border: 0.04rem solid #fff;
    }
    .info-wrap {
      position: absolute;
      top: 0.2rem;
      left: 1.68rem;
      right: 0.4rem;
      display: flex;
      height: 1.24rem;
      padding: 0.12rem;
      flex-direction: column;
      &.needLogin {
        flex-direction: row;
        align-items: center;
        &:active {
          opacity: 0.3;
        }
        .arrow-right {
          display: inline-block;
          width: 0.14rem;
          height: 0.2rem;
          margin-left: 0.12rem;
        }
      }
      .info-item {
        display: flex;
        align-items: center;
        line-height: 0.5rem;
        &.tbAccount {
          line-height: 0.44rem;
          margin-top: 0.03rem;
        }
      }
      .nickname {
        display: inline-block;
        font-size: 0.28rem;
        font-weight: bold;
        color: #fff;
        max-width: 2.12rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .mobile {
        margin-left: 0.06rem;
        display: inline-block;
        padding: 0.04rem 0.16rem;
        border-radius: 6rem;
        color: #ffc4c4;
        font-weight: 300;
      }
      .mobile-wrap {
        color: #ffc4c4;
        font-weight: 300;
      }
    }
  }
  .tb-wrap {
    display: inline-block;
    background-image: linear-gradient(-90deg, #515150, #1e1e1e);
    padding: 0 0.2rem;
    font-size: 0.24rem;
    border-radius: 0.4rem;
    &.bind {
      border-radius: 0;
      border-bottom-left-radius: 0.3rem;
      border-top-right-radius: 0.04rem;
      border-bottom-right-radius: 0.04rem;
    }
    .bind-tip {
      color: #b7b7b7;
    }
    .btn-bind {
      margin-left: 0.12rem;
      display: inline-block;
      height: 0.4rem;
      line-height: 0.4rem;
      border-radius: 0.1rem;
      color: #444444;
      background: #ffe5b2;
      padding: 0 0.2rem;
      &:active {
        opacity: 0.3;
      }
    }
    .tb-account {
      margin-left: 0.06rem;
      color: #ffe5b2;
      font-weight: bold;
    }
  }
  .mine-body {
    position: relative;
    z-index: 2;
    margin-top: -0.94rem;
    padding: 0 0.22rem;
  }
  .tool-wrap {
    // 工具列表
    margin-top: 0.3rem;
    background: #fff;
    overflow: hidden;
    .tool-item {
      position: relative;
      float: left;
      width: 25%;
      height: 1.3rem;
      padding: 0.2rem 0 0.16rem;
      text-align: center;
      &:active {
        opacity: 0.3;
      }
      .tool-icon {
        margin: 0 auto 0.14rem;
        width: 0.4rem;
        height: 0.4rem;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: auto 100%;
      }
      .tool-name {
        font-size: 0.24rem;
        color: #666;
        line-height: 0.4rem;
      }
    }
  }
}
</style>
